import type { HttpErrorResponse } from '@angular/common/http';
import type { FamilyMovePreview } from '../types/family-members.types';

/** Pure rules for moving a family plate to the member's own number (CWS-1579, CWS-1582 §7). */

const MESSAGES: Record<string, string> = {
  FAMILY_MOVE_PHONE_INVALID: 'Enter a valid phone number.',
  FAMILY_MOVE_PHONE_IS_PRIMARY: "That is the primary's number. Enter the member's own number.",
  FAMILY_MEMBER_NOT_FOUND: 'This plate is no longer in the family. Refresh and try again.',
  FAMILY_MEMBER_HAS_OWN_NUMBER: 'This plate already has a number of its own.',
  FAMILY_GROUP_NOT_FOUND: 'This family plan could not be found. Refresh and try again.',
  FAMILY_MEMBER_NAME_REQUIRED: "Enter the member's name.",
  FAMILY_CHANGED: 'The family changed while moving. Refresh and try again.',
  VEHICLE_PLATE_TAKEN: 'This plate belongs to another customer.',
};

/** The message for a refusal; the server's own text is the last resort. */
export function familyMoveErrorMessage(error: unknown): string {
  const http = error as HttpErrorResponse | null;
  const code = http?.error?.data?.code ?? http?.error?.code;
  return (
    (typeof code === 'string' ? MESSAGES[code] : undefined) ??
    http?.error?.message ??
    'The plate could not be moved. Check your connection and try again.'
  );
}

const MIN_PHONE_DIGITS = 10;

/** The number typed has enough digits to look up; the server checks the rest. */
export function isMovePhoneValid(phone: string): boolean {
  return phone.replace(/\D/g, '').length >= MIN_PHONE_DIGITS;
}

/** The name is asked for only when the number has no customer yet. */
export function needsMemberName(preview: FamilyMovePreview | null): boolean {
  return preview !== null && !preview.customer.exists;
}
